export * from './useGlobalComponentsContentfulQuery';
